export default defineNuxtRouteMiddleware(to => {
  if (process.server) return

  const { setSubdomainCookie } = useSubdomainCookie()
  const isNative = useIsNative()

  if (!to.query?.brand) return

  const brand = to.query?.brand as string
  if (!brand) return

  setSubdomainCookie(brand)

  if (to.query?.brand && !isNative) {
    const query = { ...to.query }
    delete query.brand

    return navigateTo({
      path: to.path,
      query,
    })
  }
})
